import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const keystoneConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Keystone FL Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Keystone, FL. Sam\'s Tree Service handles dangerous trees on large lots safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_keystone',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Keystone',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Keystone Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the 
     rural and semi rural properties of <strong>Keystone</strong>. This 
     unincorporated community in Northwest Hillsborough County features large 
     lots, equestrian properties, and the kind of heavily wooded acreage where 
     tree hazards grow large and fast. After a storm, downed trees block 
     driveways, lean on fences, and create serious risks for structures and animals. 
     Our team handles it all.`,

    `We specialize in <strong>large lot and rural tree removal and clearing</strong> 
     massive oak and pine removals, post storm debris cleanup, canopy clearance 
     over barns and outbuildings, and hazardous limb removal on properties where 
     access requires the right equipment and experience. No job is too big or 
     too remote for our crew.`,

    `<strong>Sam's Tree Service</strong> provides dependable, affordable tree care 
     throughout <strong>Keystone</strong> and the surrounding 
     <strong>Northwest Hillsborough</strong> rural corridor keeping your 
     land, structures, and trees safe all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Keystone, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Keystone = () => <LocationPage config={keystoneConfig} />;
export default Services_Keystone;
